import { Suspense, lazy } from 'react';

import { ToastContainer } from '@raystack/apsara';

import AppLoader from './components/AppLoader';
import { AppBreakPointScreen } from './components/Custom/BreakPoint';
import PageTitle from './components/PageTitle';
import { Show } from './hoc';
import { useBreakPoint } from './hooks';

import './App.css';

const LazyRouter = lazy(() =>
  import('./AppRouter').then(module => ({ default: module.AppRouter }))
);

function App() {
  const { isMobile } = useBreakPoint();
  const isDevelopment = import.meta.env.MODE === 'development';

  return (
    <div className='container'>
      {/* Apply default title */}
      <PageTitle />

      <Show
        when={isDevelopment || !isMobile}
        fallback={<AppBreakPointScreen />}
      >
        <Suspense fallback={<AppLoader />}>
          <LazyRouter />
        </Suspense>
      </Show>

      <ToastContainer richColors closeButton />
    </div>
  );
}
export default App;
